module.exports = __webpack_public_path__ + "media/images/requisitions/code-ab253785c41dfa9dbe24bf47b66abab2.png";